// tslint:disable:ordered-imports
// Has to be imported first to allow overriding via createGlobalStyle
import 'index.scss';

import 'react-app-polyfill/ie11';
import 'formdata-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import App from 'App';
import TagManager from 'react-gtm-module';
import { environment } from 'config/environment';

const tagManagerArgs = {
  gtmId: environment.gtmId!,
};

environment.gtmId && TagManager.initialize(tagManagerArgs);

ReactDOM.render(<App />, document.getElementById('root'));
